import axios from 'axios';

export function getAchievements(payload) {
    return axios.get(
        `${process.env.REACT_APP_REPO}/v1/repo_aden/students/${payload}/badges`
    );
}
